import { render, staticRenderFns } from "./metrics_class_performance_chart.vue?vue&type=template&id=10106bf9&scoped=true&"
import script from "./metrics_class_performance_chart.vue?vue&type=script&lang=js&"
export * from "./metrics_class_performance_chart.vue?vue&type=script&lang=js&"
import style0 from "./metrics_class_performance_chart.vue?vue&type=style&index=0&id=10106bf9&prod&lang=scss&"
import style1 from "./metrics_class_performance_chart.vue?vue&type=style&index=1&id=10106bf9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10106bf9",
  null
  
)

export default component.exports